import { Button, Col, Row, Switch, Table } from "antd";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useApi } from "../../../../../../hooks/http2";
import {
  actionMKTProduct,
  searchSelector,
} from "../../../../../../redux/slices/marketing/product";
import { axios, getToken, URL_API } from "../../../../../../utils";
import { Panel, PanelBody, PanelHeader } from "../../../../../util/panel";
import { FaPlus, FaPencilAlt, FaRegTrashAlt } from "react-icons/fa";
import { AlertConfirm, AlertError, AlertSuccess } from "../../../../../util/Alert";
import useAsync from "../../../../../../utils/useAsync";
import manageWebsiteService from "../../../../../../services/manage-website.service";
import { notFoundImg } from "../../../utils/constants/mwHomeConstants";

export default function HF_DetailList({ history, match }) {

  const dispatch = useDispatch();
  const search = useSelector(searchSelector);
  const { SET_SEARCH } = actionMKTProduct;
  const list = useApi(
    {
      baseURL: URL_API,
      url: "/manage-website/ecosystem/healthy-food/hf-detail",
      params: {
        ...search,
        offset: (search.page - 1) * search.limit,
      },
      token: true,
    },
    [search]
  );

  const { execute: deleteHF_DetailById } = useAsync(
    manageWebsiteService.deleteHF_DetailById,
    {
      onSuccess: async () => {
        await AlertSuccess("ลบข้อมูลสำเร็จ");
        list.reload();
      },
      onFailed: () => {
        AlertError();
      },
    }
  );

  const handleChangeStatus = (checked, id) => {
    axios({
      method: "post",
      baseURL: URL_API,
      url: `/manage-website/ecosystem/healthy-food/hf-detail/${id}/status`,
      headers: { Authorization: "Bearer " + getToken() },
      data: {
        status: checked ? "active" : "inactive",
      },
    })
      .then(() => {})
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <Panel>
        <PanelHeader>HF Detail</PanelHeader>
        <PanelBody>
          <Row type="flex" justify="end" gutter={16} className="mb-4">
            <Col>
              <Button
                type="primary"
                onClick={() => history.push(`${match.path}/add`)}
              >
                <FaPlus className="mr-2" />
                เพิ่มข้อมูล
              </Button>
            </Col>
          </Row>
          <Table
            bordered
            size="small"
            loading={list?.loading}
            dataSource={list?.fetch?.data || []}
            rowKey="id"
            pagination={{
              size: "default",
              showLessItems: true,
              showTotal: (total, range) =>
                `${range[0]} - ${range[1]} of ${total}`,
              total: list?.fetch?.total || 0,
              current: search.page,
              pageSize: search.limit,
              onChange: (page) => dispatch(SET_SEARCH({ page: page })),
            }}
          >
            <Table.Column
              title="No."
              key="no"
              align="center"
              dataIndex="row_id"
            />
            <Table.Column
              title="Desktop"
              key="desktop-images"
              align="center"
              dataIndex="desktop_url"
              render={(text) => (
                <img
                  src={text === null ? notFoundImg : text}
                  alt="desktop"
                  width="150px"
                />
              )}
            />
            <Table.Column
              title="Mobile"
              key="mobile-images"
              align="center"
              dataIndex="mobile_url"
              render={(text) => (
                <img
                  src={text === null ? notFoundImg : text}
                  alt="mobile"
                  width="150px"
                />
              )}
            />
            <Table.Column
              title="Public Status"
              key="public_status"
              dataIndex="status"
              align="center"
              render={(text, { id }) => (
                <Switch
                  defaultChecked={text === "active"}
                  onClick={(checked) => handleChangeStatus(checked, id)}
                />
              )}
            />

            <Table.Column
              title="Type"
              key="row_id"
              dataIndex="content_type"
              align="center"
              render={(text) => (
                <div
                  style={{
                    padding: "2px",
                    border: "1px solid #97D700",
                    borderRadius: "4px",
                  }}
                >
                  {text === "text_left"
                    ? "TEXT LEFT"
                    : text === "text_right"
                    ? "TEXT RIGHT"
                    : ""}
                </div>
              )}
            />

            <Table.Column
              title="Update Date"
              key="update_date"
              dataIndex="update_date"
              align="center"
              render={(text) =>
                text ? moment(text).format("DD/MM/YYYY HH:mm") : ""
              }
            />
            <Table.Column
              title="Manage"
              key="manage"
              align="center"
              render={(text, { id }) => (
                <Row>
                  <Link to={`${match.path}/${id}`}>
                    <Button type="primary">
                      <FaPencilAlt />
                    </Button>
                  </Link>
                  <Button
                    className="btn-danger ml-1"
                    onClick={async () => {
                      const confirm = await AlertConfirm("ลบข้อมูล");
                      if (confirm) {
                        deleteHF_DetailById(id);
                      }
                    }}
                  >
                    <FaRegTrashAlt />
                  </Button>
                </Row>
              )}
            />
          </Table>
        </PanelBody>
      </Panel>
    </>
  );
}
